var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5168 0.0433225L11.4001 0.927489L6.58596 5.74332C6.50882 5.82095 6.41709 5.88256 6.31605 5.9246C6.21501 5.96664 6.10665 5.98828 5.99721 5.98828C5.88777 5.98828 5.77942 5.96664 5.67838 5.9246C5.57733 5.88256 5.4856 5.82095 5.40846 5.74332L0.591797 0.927489L1.47513 0.0441552L5.99596 4.56416L10.5168 0.0433225Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/drop-down.03dbc9ac389e2099fd025a9ca25a5ab9.svg";
export { ForwardRef as ReactComponent };